import { useEffect } from "react";

const ORIGIN = "https://dukk.mx";

const SEO = {
  es: {
    htmlLang: "es-MX",
    title: "dukk | Detailing de Aeronaves y Cabin Care en México",
    desc: "Aircraft readiness premium, cabin care y detailing de jets privados en México. Interior, exterior, servicio prioritario y reportes de readiness para aviación privada.",
    canonical: `${ORIGIN}/aviacion`,
    ogLocale: "es_MX",
    ogLocaleAlt: "en_US",
  },
  en: {
    htmlLang: "en",
    title: "dukk | Premium Aircraft Detailing & Cabin Care Mexico",
    desc: "Premium aircraft readiness, cabin care and private jet detailing in Mexico. Interior, exterior, priority response and readiness reports for private aviation.",
    canonical: `${ORIGIN}/en/aviation`,
    ogLocale: "en_US",
    ogLocaleAlt: "es_MX",
  },
};

const OG_IMAGE = `${ORIGIN}/og-image.png`;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href, hreflang) {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ lang }) {
  const d = SEO[lang] || SEO.es;
  useEffect(() => {
    document.documentElement.lang = d.htmlLang;
    document.title = d.title;
    upsertMeta("name", "description", d.desc);
    upsertLink("canonical", d.canonical);

    // hreflang (same set on both pages)
    upsertLink("alternate", `${ORIGIN}/aviacion`, "es-MX");
    upsertLink("alternate", `${ORIGIN}/en/aviation`, "en");
    upsertLink("alternate", `${ORIGIN}/aviacion`, "x-default");

    // Open Graph
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "dukk");
    upsertMeta("property", "og:title", d.title);
    upsertMeta("property", "og:description", d.desc);
    upsertMeta("property", "og:url", d.canonical);
    upsertMeta("property", "og:image", OG_IMAGE);
    upsertMeta("property", "og:image:width", "1264");
    upsertMeta("property", "og:image:height", "848");
    upsertMeta("property", "og:locale", d.ogLocale);
    upsertMeta("property", "og:locale:alternate", d.ogLocaleAlt);

    // Twitter Card
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", d.title);
    upsertMeta("name", "twitter:description", d.desc);
    upsertMeta("name", "twitter:image", OG_IMAGE);
  }, [lang, d]);
  return null;
}
